import React, {ReactNode} from "react";
import Hint from "./Hint";

interface Props {
    text: string
    hint?: string,
    htmlFor?: string,
    children?: ReactNode,
}

const Label: React.FC<Props> = (
    {
        text,
        hint,
        htmlFor = null,
        children = '',
    }
) => {
    return (
        <label
            {...(htmlFor ? { htmlFor: htmlFor } : {})}
          className="text-[0.9rem] text-slate-600 dark:text-slate-400 pb-1"
        >
          { children ? <>
              <div className="text-sm flex items-center">
                {text}
                {hint && <Hint text={hint} />}
              </div>
              {children}
            </> : <>
              {text}
              {hint && <Hint text={hint} />}
          </>}
        </label>
    );
}

export default Label;